import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

export const ConversationRefreshContext = createContext();

export const ConversationRefreshProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  const value = {
    refreshKey,
    triggerRefresh
  };

  return (
    <ConversationRefreshContext.Provider value={value}>
      {children}
    </ConversationRefreshContext.Provider>
  );
};

ConversationRefreshProvider.propTypes = {
  children: PropTypes.node.isRequired
};